import { Component, Input, OnInit, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Params, Router} from '@angular/router';
import { Location } from '@angular/common';
import { ContentService } from '../shared/content.service';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { NotificationService } from '../shared/notification.service';

// import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';

const type: string = 'special';

@Component({
    template: require('./partials/content-specials.component.html')
})
export class ContentSpecialsComponent implements OnInit, AfterContentChecked {
    
    public currentLanguage: string; 
    public contents: any;

    //private toastyService:ToastyService, private toastyConfig: ToastyConfig,
    constructor(private config: ConfigService, private notification:NotificationService, public utils: UtilsService, private contentService: ContentService, private route: ActivatedRoute, private location: Location, private router: Router) {
        // this.toastyConfig.theme = 'material';
    }

    onStatusChange(status: any, item: any){
        item.active = status;
        this.contentService.saveContent(type, 'update', item).then(res =>{
            console.log("Content "+type+" set to "+status);
        });
    }

    public setContents(){
        this.route.params
            .switchMap((params: Params) => this.contentService.getContents(type, true)) // no cache
            .subscribe(response => {
                this.contents = response;
            });
    }

    public deleteContent(type: string, id: string){
        this.contentService.deleteContent(type,id);
        this.router.navigate(['specials/reload'], {relativeTo: this.route.parent});
        setTimeout(() => {
            this.router.navigate(['specials'], {relativeTo: this.route.parent});
        }, 500);
    }

    ngOnInit(){
        this.setContents();
        this.route.parent.params.subscribe(
            (params: Params) => {
                this.currentLanguage = params['lg'];
            }
        );
    }
    ngAfterContentChecked(){
        if(!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-specials.component.ts